<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="idPromo + '-' + desc + ' cond. clientes'" titulo="Promociones">
  </app-lfsa-card-v2>
</div>

<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
    <div *ngIf="!verFormularioAgregarCondCliente">
      <button class="btn btn-outline-danger me-2" routerLink="..">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button class="btn btn-outline-success" (click)="nuevoCondCliente()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        Nueva condición
      </button>
    </div>
  </div>
</ng-template>

<ng-template #enviarTemplateEdit>
  <div *ngIf="!verFormularioAgregarCondCliente">
    <button class="btn btn-danger mb-3" (click)="eliminarTodo()">Eliminar todo</button>
    <ag-grid-angular #agGridBonificadores (gridReady)="onGridReady($event)" class="ag-theme-alpine"
      [columnDefs]="columnDefsCondCliente" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
      id="myGridListGaritas" [ngStyle]="{width: '100%', height: '400px'}" [paginationPageSize]="15"
      [pagination]="true" [rowData]="rowDataCondCliente">
    </ag-grid-angular>
  </div>
  <app-promo-cliente-form
    [clienteForm]="cliente"
    [idPromo]="idPromo"
    [tipoPromo]="tipoPromo"
    [cliente]="clienteModal"
    (back)="back()"
    (create)="guardarCondCliente($event)"
    *ngIf="verFormularioAgregarCondCliente"></app-promo-cliente-form>
</ng-template>
<ng-container *ngIf="verFormularioAgregarCondCliente">
  <app-cliente-modal (onSelect)="clienteSelected($event)"></app-cliente-modal>
</ng-container>
